export default __webpack_public_path__ + "static/media/CRYSTALLINE_16x9_MASTER_220625.6387ccf7.mp4";